export const DatasLeiloes = [
  {
    name: 'Amazonas',
    cidades: [
      {
        nameCidade: 'Manaus',
        leiloeiro: 'Pacto leilões - Manaus / AM',
        endereco: 'Rua Waldemar Jardim Maués, 1265, Novo Aleixo - CEP 69098-455 Manaus-AM',
        datas: '09/09/2026 | 16/09/2026 | 23/09/2026 | 28/09/2026',
        site: 'www.pactoleiloes.com.br',
        url: 'https://www.pactoleiloes.com.br',
      },
    ],
  },
  {
    name: 'Bahia',
    cidades: [
      {
        nameCidade: 'Candeias',
        leiloeiro: 'Guariglia Leilões',
        endereco: 'Rodovia BA - 522, 3480 - Caroba - Candeias - BA - CEP: 43841-000',
        datas: '10/09/2026 | 24/09/2026',
        site: 'www.guariglialeiloes.com.br',
        url: 'https://www.guariglialeiloes.com.br',
      },
    ],
  },
  {
    name: 'Ceará',
    cidades: [
      {
        nameCidade: 'Fortaleza',
        leiloeiro: 'Pacto leilões',
        endereco:
          'Rua Neuza Freitas de Sá, S/N, Bairro Jabuti, Município de Eusébio-CE CEP 61.760.000',
        datas: '09/09/2026 | 16/09/2026 | 23/09/2026 | 28/09/2026',
        site: 'www.pactoleiloes.com.br',
        url: 'https://www.pactoleiloes.com.br',
      },
      {
        nameCidade: 'Fortaleza',
        leiloeiro: 'Win Leilões',
        endereco:
          'Rua Coronel Zacarias José de França, 255 - a - Cajazeiras, Fortaleza - CE, 60864-460',
        datas: '08/09/2026 | 15/09/2026 | 22/09/2026 | 29/09/2026',
        site: 'www.winleiloes.com.br',
        url: 'https://www.winleiloes.com.br/',
      },
    ],
  },
  {
    name: 'Distrito Federal',
    cidades: [
      {
        nameCidade: 'Brasília',
        leiloeiro: 'Gian Braggio',
        endereco: 'AE 08, Lote D, Guará II, Brasília - DF',
        datas: '03/09/2026 | 23/09/2026',
        site: 'www.parquedosleiloes.com.br',
        url: 'https://www.parquedosleiloes.com.br',
      },
    ],
  },
  {
    name: 'Goiás',
    cidades: [
      {
        nameCidade: 'Goiânia',
        leiloeiro: 'Leilomaster',
        endereco: 'Rua 23, n.40 - Santo Antonio, Goiania - GO, 74853-360',
        datas: '01/09/2026 | 08/09/2026 | 15/09/2026 | 22/09/2026 | 29/09/2026',
        site: 'www.leilomaster.com.br',
        url: 'https://www.leilomaster.com.br',
      },
      {
        nameCidade: 'Goiânia',
        leiloeiro: 'Win Leilões',
        endereco: 'Alameda Anicuns, 2 - 740 - Esplanada do Anicuns, Goiânia - GO, 74420-130',
        datas: '08/09/2026 | 15/09/2026 | 22/09/2026 | 29/09/2026',
        site: 'www.winleiloes.com.br',
        url: 'https://www.winleiloes.com.br/',
      },
    ],
  },
  {
    name: 'Mato Grosso',
    cidades: [
      {
        nameCidade: 'Varzea Grande',
        leiloeiro: 'Win Leilões',
        endereco:
          'Ponte Nova, R. José Sarate (Construmat), 549 - Construmat, Várzea Grande - MT, 78115-280',
        datas: '08/09/2026 | 15/09/2026 | 22/09/2026 | 29/09/2026',
        site: 'www.winleiloes.com.br',
        url: 'https://www.winleiloes.com.br/',
      },
    ],
  },
  {
    name: 'Minas Gerais',
    cidades: [
      {
        nameCidade: 'Belo Horizonte',
        leiloeiro: 'Bolsa de Leilões',
        endereco: 'Anel Rodov. Celso Mello Azevedo, 3713 - Belo Horizonte, MG',
        datas: '16/09/2026',
        site: 'www.bolsadeleiloes.com.br',
        url: 'https://www.bolsadeleiloes.com.br/',
      },
    ],
  },
  {
    name: 'Pará',
    cidades: [
      {
        nameCidade: 'Benevides',
        leiloeiro: 'Pacto leilões',
        endereco: 'Rod. BR 316, Km 20 - n° 100- Canutama - Benevides/PA',
        datas: '09/09/2026 | 16/09/2026 | 23/09/2026 | 28/09/2026',
        site: 'www.pactoleiloes.com.br',
        url: 'https://www.pactoleiloes.com.br',
      },
      {
        nameCidade: 'Marituba',
        leiloeiro: 'Norte Leilões',
        endereco: 'Rod. BR 316, Km 18 - Marituba/PA',
        datas: '23/09/2026',
        site: 'www.norteleiloes.com.br',
        url: 'https://www.norteleiloes.com.br',
      },
    ],
  },
  {
    name: 'Pernambuco',
    cidades: [
      {
        nameCidade: 'Recife',
        leiloeiro: 'COPART',
        endereco: 'Rod. Luiz Gonzaga, BR 232 -KM 41 - Vitoria de St. Antão/PE CEP: 55612-015',
        datas: '03/09/2026 | 10/09/2026 | 17/09/2026 | 24/09/2026',
        site: 'www.copart.com.br',
        url: 'https://www.copart.com.br/',
      },
      {
        nameCidade: 'Paulista ',
        leiloeiro: 'Win Leilões',
        endereco: 'Av. Antônio Cabral de Souza, 1000 - Maranguape II, Paulista - PE, 53409-420',
        datas: '08/09/2026 | 15/09/2026 | 22/09/2026 | 29/09/2026',
        site: 'www.winleiloes.com.br',
        url: 'https://www.winleiloes.com.br/',
      },
    ],
  },
  {
    name: 'Paraná',
    cidades: [
      {
        nameCidade: 'Curitiba',
        leiloeiro: 'Cláudio Kuss Leiloeiro',
        endereco: 'Rua João Lunardelli, 2095, CIC Curitiba / PR',
        datas: '01/09/2026 | 09/09/2026 | 15/09/2026 | 22/09/2026 | 29/09/2026',
        site: 'www.claudiokussleiloes.com.br',
        url: 'https://www.claudiokussleiloes.com.br/',
      },
    ],
  },
  {
    name: 'Rio de Janeiro',
    cidades: [
      {
        nameCidade: 'Rio de Janeiro',
        leiloeiro: 'Rogério Menezes Leiloeiro',
        endereco: 'Av. Brasil, 51.467 (esquina com Rua Agai), Campo Grande/RJ',
        datas: '02/09/2026 | 09/09/2026 | 16/09/2026 | 23/09/2026 | 30/09/2026',
        site: 'www.rogeriomenezes.com.br',
        url: 'https://www.rogeriomenezes.com.br',
      },
    ],
  },
  {
    name: 'Rio Grande do Sul',
    cidades: [
      {
        nameCidade: 'Porto Alegre',
        leiloeiro: 'Pestana Leilões',
        endereco:
          'Centro Logístico de Nova Santa Rita: BR386 - KM 431 - Nova Santa Rita/RS CEP 92480-000',
        datas: '02/09/2026 | 09/09/2026 | 15/09/2026 | 22/09/2026',
        site: 'www.pestanaleiloes.com.br',
        url: 'https://www.pestanaleiloes.com.br',
      },
    ],
  },
  {
    name: 'São Paulo',
    cidades: [
      {
        nameCidade: 'Caçapava',
        leiloeiro: 'Guariglia Leiloeiro',
        endereco: 'Av. Henry Nestlé, 1500 Caçapava, SP',
        datas: '03/09/2026 | 10/09/2026 | 17/09/2026 | 24/09/2026',
        site: 'www.guariglialeiloes.com.br',
        url: 'https://www.guariglialeiloes.com.br',
      },
      {
        nameCidade: 'Mogi das Cruzes',
        leiloeiro: 'Loop Brasil',
        endereco: 'Rua Projetada um,143 - Mogi das Cruzes/SP',
        datas:
          '03/09/2026 | 08/09/2026 | 10/09/2026 | 12/09/2026 | 15/09/2026 | 17/09/2026 | 22/09/2026 | 24/09/2026 | 26/09/2026 | 28/09/2026',
        site: 'www.loopleiloes.com.br',
        url: 'https://loopleiloes.com.br/',
      },
      {
        nameCidade: `Santa Barbára D'Oeste`,
        leiloeiro: 'Freitas Leiloeiro',
        endereco: `Av. Pres. Juscelino K. de Oliveira, 1360 - Santa Barbara D'Oeste, SP`,
        datas: '02/09/2026 | 09/09/2026 | 16/09/2026 | 19/09/2026 | 23/09/2026 | 30/09/2026',
        site: 'www.freitasleiloeiro.com.br',
        url: 'https://www.freitasleiloeiro.com.br',
      },
      {
        nameCidade: 'Utinga',
        leiloeiro: 'Freitas Leiloeiro',
        endereco: 'Av. dos Estados, 584 Santo André, SP',
        datas:
          '01/09/2026 | 04/09/2026 | 08/09/2026 | 11/09/2026 | 15/09/2026 | 18/09/2026 | 22/09/2026 | 25/09/2026 | 29/09/2026',
        site: 'www.freitasleiloeiro.com.br',
        url: 'https://www.freitasleiloeiro.com.br',
      },
    ],
  },
];
